import React from 'react'

function Projects() {
  return (
    <div className='project-section text-white mb-8'>~ Projects Section Coming Soon ~</div>
  )
}

export default Projects